export const initFormie = () => {
  // Reload after the contact form submits. Delegated on document rather than
  // bound inside onFormieInit: Firefox initialises the form (from Formie's
  // IntersectionObserver) before DOMContentLoaded, so a listener registered
  // there misses the init event and never attaches.
  document.addEventListener("onAfterFormieSubmit", (e) => {
    if (e.target.dataset.formHandle !== "contactUs") return;
    // The in-page copy (Card Page "Form" field) has no modal to reset, so it keeps Formie's success message instead
    if (e.target.closest("#page-form")) return;
    setTimeout(() => {
      location.reload();
    }, 6000);
  });

  // Input field floating labels. Inputs are server-rendered, so no need to wait for Formie.
  document.querySelectorAll("input").forEach((el) => {
    const labels = document.getElementsByTagName("LABEL");
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].htmlFor != "") {
        let elem = document.getElementById(labels[i].htmlFor);
        if (elem) elem.label = labels[i];
      }
    }

    el.addEventListener("focus", (e) => {
      if (e) {
        document.getElementById(el.id).label.classList.add("focused");
        el.classList.add("focused");
      }
    });

    el.addEventListener("blur", (e) => {
      if (e) {
        document.getElementById(el.id).label.classList.remove("focused");
        el.classList.remove("focused");
      }
    });

    el.addEventListener("input", (e) => {
      if (e.target.value) {
        document.getElementById(el.id).label.classList.add("has-value");
        el.classList.add("has-value");
      } else {
        document.getElementById(el.id).label.classList.remove("has-value");
        el.classList.remove("has-value");
      }
    });
  });
};
